import React from 'react'

const Spacer = ({top,bottom}) => {
  return (
    <div className="mt-6"></div>
  )
}

export default Spacer